import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { getSeatSlots } from 'store/updateTicketing';
import { accessNested } from 'utils/utils';
import { getCopy } from 'utils/copy';
import CanvasSeatPicker from 'components/shared/theaters/ticketing/ticketSeating/canvasSeatPicker';
import s from 'components/shared/theaters/ticketing/ticketSeating/ticketSeating.sss';
import bb from 'components/shared/theaters/ticketing/bottomBar.sss';


export default class TicketSeating extends Component {

	componentDidMount() {
		Store.emit(actions.START_FORCE_CLIENT_ORIENTATION, 'portrait');
	}

	componentDidUpdate() {
		if (this.$canvasSeating && typeof this.$canvasSeating.onResize === 'function') {
			this.$canvasSeating.onResize();
		}
	}

	componentWillUnmount() {
		Store.emit(actions.STOP_FORCE_CLIENT_ORIENTATION);
	}

	goToNext = () => {
		Store.emit(actions.UPDATE_TICKETING_SEATS);
	}

	goBack = () => {
		Store.emit(actions.GO_TICKETING_TYPES);
	}

	render(props) {
		const {
			ticketing, // Object - the ticketing state
			appData,   // Object - the app data
			client     // Object - the client info
		} = props;

		const seatSlots = getSeatSlots(ticketing);
		const controlsDisabled = ticketing.apiLoading || ticketing.apiMessage;

		return (
			<div class={s.stepContainer}>
				<div class={s.container}>
					<h1 class={this.state.zoom ? s.headerZoom : s.header}>{getCopy('WHICH_SEATS')}</h1>
					<div class={s.canvasContainer}>
						<CanvasSeatPicker
							seatLayout={accessNested(ticketing, 'seating', {})}
							pickedSeats={accessNested(ticketing, 'pickedSeats', [])}
							controlsDisabled={controlsDisabled}
							appData={appData}
							client={client}
							ref={$ref => this.$canvasSeating = $ref}
						/>
					</div>
				</div>
				<div class={bb.wrapper}>
					<div class={bb.info}>
						<div class={s.seatDetails}>
							{seatSlots.map((seat) => {
								if (seat) {
									return <div class={s.seatSlot} onClick={this.goBack}>{`${seat.rowLabel}${seat.seatLabel}`}</div>;
								} else {
									return <div class={s.seatSlotEmpty} onClick={this.goBack}></div>;
								}
							})}
							<div class={s.seatSlotEmpty} onClick={this.goBack}>+</div>
						</div>
					</div>
					<div class={bb.buttonWrapper}>
						<button class={bb.button} onClick={this.goToNext}>{getCopy('NEXT')}</button>
					</div>
				</div>
			</div>
		);
	}

}
